/*  utils/timezones.js  – full file (v2)
    -------------------------------------------------------------
    • On modern browsers / Node ≥18 the new Intl API exposes the
      complete IANA database via Intl.supportedValuesOf('timeZone').
    • Older environments fall back to a concise list so the picker
      still works (edit the fallback as you like).
---------------------------------------------------------------- */

export const TIMEZONES = (() => {
  // Modern spec: returns an array of every valid IANA zone
  if (typeof Intl?.supportedValuesOf === 'function') {
    try {
      return Intl.supportedValuesOf('timeZone')
    } catch {
      /* some polyfills throw if the key isn’t recognised – ignore */
    }
  }

  // Fallback for very old browsers / Node versions (<18)
  return [
    'UTC',
    'Africa/Abidjan',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Harare',
    'Africa/Johannesburg',
    'America/Anchorage',
    'America/Argentina/Buenos_Aires',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/New_York',
    'America/Phoenix',
    'Asia/Dubai',
    'Asia/Hong_Kong',
    'Asia/Kolkata',
    'Asia/Singapore',
    'Asia/Tokyo',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Sydney',
    'Europe/Berlin',
    'Europe/London',
    'Europe/Moscow',
    'Europe/Paris',
    'Pacific/Auckland',
    'Pacific/Honolulu'
  ]
})()
